import { useState, type FC } from "react";
import classNames from "classnames";
import { SettingIcon, MoonIcon, LogoutIcon, MessageWithAQuestion } from "@/shared/icons";
import { AppButton, AppNavLink } from "@/shared/Components";
import { useTheme } from "@/services/theme";
import { useAuth } from "@/services/auth";
import { appRouterPaths } from "@/services/navigation";
import { useModal } from "@/features/modals/lib";
import { ModalLogout } from "@/features/modals/ModalLogout";
import { ModalSupport } from "@/features/modals/ModalSupport";
import styles from "./styles.module.scss";

export const HeaderControlButtons: FC = () => {
  const { toggleTheme } = useTheme();
  const { logoutHandler } = useAuth();
  const { showModal, hideModal, isModalOpen } = useModal();

  const [supportModal, setSupportModal] = useState(false);

  return (
    <div className={styles["container"]}>
      <AppNavLink to={appRouterPaths.settings}>
        {({ isActive }) => {
          return (
            <AppButton
              icon={
                <SettingIcon
                  className={classNames(styles.icon, { [styles["icon-active"]]: isActive })}
                />
              }
              className={classNames(styles["icon-button"], {
                [styles.active]: isActive,
              })}
            />
          );
        }}
      </AppNavLink>
      <AppButton
        icon={<MoonIcon className={styles.icon} />}
        onClick={toggleTheme}
        className={styles["icon-button"]}
      />
      <AppButton
        icon={<MessageWithAQuestion className={styles.icon} />}
        onClick={() => setSupportModal(true)}
        className={styles["icon-button"]}
      />
      <AppButton
        icon={<LogoutIcon className={styles.icon} />}
        onClick={showModal}
        className={styles["icon-button"]}
      />
      <ModalLogout open={isModalOpen} onOk={logoutHandler} onCancel={hideModal} />
      <ModalSupport open={supportModal} onCancel={() => setSupportModal(false)} />
    </div>
  );
};
